import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/seek.js
const SeekIcon = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M1 9c0 2.21.895 4.21 2.343 5.657l1.06-1.06a6.5 6.5 0 1 1 9.665-8.665l-1.641 1.641a.25.25 0 0 0 .177.427h4.146a.25.25 0 0 0 .25-.25V2.604a.25.25 0 0 0-.427-.177l-1.438 1.438A8 8 0 0 0 1 9" })
});
const ForwardRef = forwardRef(SeekIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=seek.js.map